import React from "react";

export function CheckAssistantIcon({ color = "#fff" }) {
  return (
    <svg
      id="check-assistant-icon"
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
    >
      <path
        d="M11.6666 3.5L5.24992 9.91667L2.33325 7"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
